export const getMainOrDefault = (mainId: any, objects: any) => {
    if (mainId && objects){ return objects.find((c: any) => c.id === mainId) }
    else if (objects){ return objects[0] }
    else{ return {} }
}
